module.exports = __webpack_public_path__ + "img/b2f5088.jpg";